import _window from "@src/libraries/window";
import analytics from "@src/store/analytics";
import { API_V2_URL, timeout } from "@src/assets/js/utils";
import { persistent } from "@src/assets/js/requests/storage";
import usersStore from "@src/store/users";
export async function login(driver, referrer) {
    usersStore.loading = "login " + driver;
    console.log("login:", driver);
    await usersStore.logout();
    await persistent.setItem("login_driver", driver);
    analytics.page("login", { driver });
    if (_window.cordova) {
        if ("google" == driver && !/\bhms\b/i.test(navigator.userAgent)) {
            await usersStore.loginCordovaGoogle();
            await timeout(2000);
            usersStore.loading = "";
            return;
        }
        if ("facebook" == driver && _window.facebookConnectPlugin) {
            usersStore.loginCordovaFacebook();
            return;
        }
    }
    await loginWeb(driver, referrer);
    await timeout(3000);
    usersStore.loading = "";
}
;
function loginWeb(driver, referrer) {
    const location = _window.location;
    if (!location)
        return false;
    if (referrer && !referrer.includes("http"))
        referrer = location.origin + referrer;
    const path = encodeURIComponent(referrer || location.href);
    const url = API_V2_URL + "/auth/" + driver + "?referer=" + path;
    location.href = url;
    return true;
}
;
